var HasaAudio = function (key) {
    return this.sound.game.cache.audio.has(key);
}

export default HasaAudio;